import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function usePaymentcredentialQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const paymentcredentialListQuery = useQuery({
        queryKey: ["payment-credentials"],
        queryFn: () =>
            axiosPrivate
                .get("payment-credentials/")
                .then(r => r.data),
    });

    const usePaymentcredentialQuery = (id) =>
        useQuery({
            queryKey: ["payment-credentials", id],
            queryFn: () =>
                axiosPrivate
                    .get(`payment-credentials/${id}/`)
                    .then(r => r.data),
            enabled: !!id,
        });

    // MUTATIONS ------------------------------------------------------

    const useCreatePaymentcredential = (onSuccess) =>
        useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("payment-credentials/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["payment-credentials"]);
                onSuccess && onSuccess(...args);
            },
        });

    const useUpdatePaymentcredential = (onSuccess) =>
        useMutation({
            mutationFn: ({id, data}) =>
                axiosPrivate
                    .put(`payment-credentials/${id}/`, data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["payment-credentials"]);
                onSuccess && onSuccess(...args);
            },
        });

    const useDeletePaymentcredential = (onSuccess) =>
        useMutation({
            mutationFn: (id) =>
                axiosPrivate
                    .delete(`payment-credentials/${id}/`)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["payment-credentials"]);
                onSuccess && onSuccess(...args);
            },
        });

    const usePaymentcredentialMakeActive = (onSuccess) =>
        useMutation({
            mutationFn: (id) =>
                axiosPrivate
                    .get(`payment-credentials/${id}/make_active/`)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["payment-credentials"]);
                onSuccess && onSuccess(...args);
            },
        });

    const usePaymentcredentialDeactivate = (onSuccess) =>
        useMutation({
            mutationFn: (id) =>
                axiosPrivate
                    .get(`payment-credentials/${id}/deactivate/`)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["payment-credentials"]);
                onSuccess && onSuccess(...args);
            },
        });

    // RETURN HOOKS ------------------------------------------------------

    return {
        paymentcredentialListQuery,
        usePaymentcredentialQuery,

        useCreatePaymentcredential,
        useUpdatePaymentcredential,
        useDeletePaymentcredential,

        usePaymentcredentialMakeActive,
        usePaymentcredentialDeactivate,
    };
}
